import OnboardingAddToPlaylist from './OnboardingAddToPlaylist'

export default OnboardingAddToPlaylist
// eslint-disable-next-line import/export
export * from './OnboardingAddToPlaylist'
